define('common/browserFeatureSupport',[], function() {
    'use strict';
    
    return {
        isLocalStorageSupported : isLocalStorageSupported    
    };

    function isLocalStorageSupported(){
        var localStorageFlag;

        try {
            localStorageFlag = (('localStorage' in window) && window.localStorage !== null);
        } catch (e) {
            localStorageFlag = false;
        }

        if(localStorageFlag){
            try{
                window.localStorage.setItem('test', 'test');
                window.localStorage.removeItem('test');
            } catch(e){
                localStorageFlag = false;
                console.warn('Operations Insights Error : localStorage not functional :- '+ e );
            }
        }

        return localStorageFlag;
    }


});
